import { RedoFulfillmentToteSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote";
import { locationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const createTotes = {
  name: "createTotes" as const,
  input: z.object({
    totes: z.array(
      z.object({
        name: z.string(),
        barcode: z.string().nullish(),
        locationId: locationIdFormat.schema,
      }),
    ),
  }),
  output: z.object({ totes: z.array(RedoFulfillmentToteSchema) }),
};

export type CreateTotesInput = z.infer<typeof createTotes.input>;
